/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useState, useContext } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { LoginContext } from '../App';
import CommonHeader from '../UiComponents/Header/CommonHeader';
import SideNav from '../UiComponents/SideNav';
import NotificationView from '../UiComponents/SideNav/components/NotificationView';
import Notifications from '../UiComponents/SideNav/components/Notifications';
import LicenseSubscriptions from '../containers/LicenseSubscription';
import '../UiStyles/RightSlider/styles.css';

interface HeaderSidebarLayoutHocProps {
	children: React.ReactNode;
}

interface NotifyViewData {
	type?: string;
	[key: string]: any;
}

interface NotifyView {
	state: boolean;
	data: NotifyViewData | null;
}

const HeaderSidebarLayoutHoc: React.FC<HeaderSidebarLayoutHocProps> = ({ children }) =>
{
	const { loading } = useContext(LoginContext);
	const session = useSelector((state: any) => state?.mysession?.session);
	const location = useLocation();
	const [ notificationSlider, setNotificationSlider ] = useState(false);
	const [ notifyView, setNotifyView ] = useState<NotifyView>({ state: false, data: null });
	const [ notificationStatus, setNotificationStatus ] = useState(false);
	const isEmpActive = session?.isActive === 'active';

	// Check if user is authenticated
	const isAuthenticated = session && Object.keys(session).length > 0 && session?.userId;

	// Don't render header for auth pages and employee pending page
	const authPaths = [ '/', '/forgot', '/reset-password', '/newUserResetPassword', '/success-screen', '/otp-verify', '/signup', '/company', '/employee', '/individual', '/company-signup', '/employee-signup', '/individual-signup', '/declined', '/emp' ];
	const isAuthPath = authPaths.some((path) => location.pathname === path || location.pathname.startsWith(`${path}/`));

	// Don't render header and sidebar for certification exam pages
	const examPaths = [ '/certification/startexam', '/examStatus' ];
	const isExamPath = examPaths.some((path) => location.pathname.includes(path));

	// Don't render if not authenticated or on auth pages
	if (!isAuthenticated || isAuthPath)
	{
		return <>{children}</>;
	}

	// Don't render header and sidebar for exam pages
	if (isExamPath)
	{
		return <>{children}</>;
	}

	return (
		<>
			{!loading && isEmpActive && <SideNav />}
			{!loading && isEmpActive && (
				<>
					<CommonHeader
						setNotificationSlider={setNotificationSlider}
						setNotifyView={setNotifyView}
						notificationSlider={notificationSlider}
						notificationStatus={notificationStatus}
					/>
				</>
			)}
			{!loading && (
				<>
					{children}
					{/* Notification Slider Overlay and UI */}
					<button
						className={notificationSlider ? 'overlayNotifySlider fadeInOverlay' : ''}
						tabIndex={0}
						onKeyUp={(e) => { e.key === 'Enter' && setNotificationSlider(!notificationSlider); }}
						onClick={() => { setNotificationSlider(!notificationSlider); }}
					/>
					<div className={notificationSlider ? 'flexCol fxdNotifySlider slideIn' : ''}>
						{notificationSlider && (
							<Notifications
								setNotificationSlider={setNotificationSlider}
								notifyView={notifyView}
								setNotifyView={setNotifyView}
								setNotificationStatus={setNotificationStatus}
							/>
						)}
					</div>
					<button
						className={notifyView.state ? 'overlayNotifySlider fadeInOverlay' : ''}
						tabIndex={0}
						onKeyUp={(e) => { e.key === 'Enter' && setNotifyView({ state: false, data: null }); }}
						onClick={() => { setNotifyView({ state: false, data: null }); }}
					/>
					<div className={notifyView.state ? 'flexCol fxdNotifyViewSlider slideIn' : ''}>
						{notifyView?.state && notifyView?.data && (
							<>
								{notifyView.data.type === 'License Expired Reminder'
									? <LicenseSubscriptions setOpenPlanSlider={setNotifyView} />
									: <NotificationView setNotificationSlider={setNotificationSlider} data={notifyView.data} setNotifyView={setNotifyView} />
								}
							</>
						)}
					</div>
				</>
			)}
		</>
	);
};

export default HeaderSidebarLayoutHoc;
